import './style.scss';
import { TranslationService } from '../../../services/translation.service';
import exclamationCircleRedIcon from '../../../../assets/icons/exclamation-circle-red-600.svg';
import DataUrlHelper from '../../../helpers/data-url.helper';

function ValidationSummary({ validationSummaryErrors, className, id }: { validationSummaryErrors: string[]; className?: string; id?: string }) {
  return (
    <div id={id || undefined} className={`validation-summary ${validationSummaryErrors.length > 0 ? 'has-validation-errors' : ''} ${className ?? ''}`} tabIndex={-1}>
      {validationSummaryErrors.length > 0 && (
        <div className="validation-error rounded position-relative border border-red p-3 p-sm-4">
          <div className="d-flex align-items-center mb-2">
            <img alt="" className="me-2" src={DataUrlHelper.encode(exclamationCircleRedIcon)} />
            <span className="h3 mb-0">{TranslationService.get('common.validation.validationsummaryheading')}</span>
          </div>
          {validationSummaryErrors.length === 1 ? (
            <div className="mb-0">{validationSummaryErrors[0]}</div>
          ) : (
            <ol className="ps-3 mb-0 last-child-margin-bottom-none">
              {validationSummaryErrors.map((validationError, index) => (
                <li key={index} className="mb-1">
                  {validationError}
                </li>
              ))}
            </ol>
          )}
        </div>
      )}
    </div>
  );
}

export default ValidationSummary;
